import lodash from 'lodash'
import React, { useEffect } from 'react'
import { ReactElement } from 'react'
import { useForm } from 'react-final-form'
import styled from 'styled-components'

import useFieldState from '../../../../../../1stlog-ui/src/components/Field/useFieldState'
import FieldArrayControl from '../../../../../../1stlog-ui/src/components/FieldArrayControl'
import TariffsDialog from '../../../../TariffsDialog'
import { TOrderEntryCustomsItem } from '../../../types'
import CustomsItem from '../CustomsItem'
import CustomsValidation from '../CustomsValidation'

const Wrapper = styled.div``

const DEFAULT_CUSTOMS_CURRENCY = 'EUR'

type TCustomsCollectionProps = {
  currentCustomer: any
  name: string
  exportCountryField: string
  importCountryField: string
  isOptional: boolean
}

const CustomsCollection = (props: TCustomsCollectionProps): ReactElement => {
  const {
    currentCustomer,
    name = 'customs',
    exportCountryField,
    importCountryField,
    isOptional,
  } = props

  const [customs, setCustoms] = useFieldState<TOrderEntryCustomsItem[]>(name)

  const form = useForm()

  const generateCustomsItem = (): TOrderEntryCustomsItem => {
    const firstItem = lodash.first(
      lodash.get(form?.getState()?.values, name),
    ) as TOrderEntryCustomsItem
    return {
      count: 1,
      value: {
        value: 0,
        currency:
          firstItem?.value?.currency ||
          currentCustomer?.defaultCurrency ||
          DEFAULT_CUSTOMS_CURRENCY,
      },
      originCountry: lodash.get(currentCustomer, 'defaultCountry'),
      articleNumber: '',
      description: '',
      grossWeight: 0,
      id: '',
      netWeight: 0,
    }
  }

  useEffect(() => {
    if (lodash.isEmpty(customs) && !isOptional) {
      setTimeout(() => setCustoms([generateCustomsItem()]), 0)
    }
  }, [customs, isOptional])

  return (
    <Wrapper>
      <TariffsDialog id="export" />
      <TariffsDialog id="import" />
      <CustomsValidation />
      <FieldArrayControl
        flush
        // innerStyle={{ margin: '0 -12px' }}
        name={name}
        FieldComponent={CustomsItem}
        newElement={generateCustomsItem()}
        addText={i18n.t('add_customs_item', 'Zollpflichtige Ware hinzufügen')}
        additionalProps={{
          exportCountryField,
          importCountryField,
          isOptional,
        }}
      />
    </Wrapper>
  )
}

export default CustomsCollection
